module.exports = __webpack_public_path__ + "media/images/logo_urban-0e883d53b43f3de9a1fe2449871396ff.png";